module.exports = __webpack_public_path__ + "img/funnel.7211d9a4.png";